<!--
입고스캔 > 메인 컴포넌트
------------------------------------
-->
<template>
    <div class="uk-flex uk-flex-column uk-flex-between uk-flex-stretch uk-height-1-1">
        <!-- 상단헤더 영역 -->
        <layout-header
            :region-id="regionId"
            :scan="scan"
            :ship-in-list="shipInList"
        >
        </layout-header>


        <!-- 컨텐츠 영역 -->
        <div class="uk-height-1-1 uk-overflow-auto">
            <scan
                class=""
                ref="scan"
                :csrf-token="csrfToken"
                :region-id="regionId"
                :scan="scan"

                v-on:update:scan="scanListener($event)"

                v-show="displayScan"
            >
            </scan>

            <ship-in-list
                class=""
                ref="list"
                :csrf-token="csrfToken"
                :region-id="regionId"
                :ship-in-list="shipInList"

                v-show="displayList"
            >
            </ship-in-list>

        </div>

        <!-- 하단푸터 영역-->
        <layout-footer
            :region-id="regionId"
            :login-user-name="loginUserName"
            :auto-print="autoPrint"
        >
        </layout-footer>

        <!-- 사운드 -->
        <audio controls="controls">
            <source src="/ship-in-sound/normal.mp3" type="audio/mpeg" />
            Your browser does not support the audio element.
        </audio>

    </div>
</template>

<script>

    import regionAble from "../../common/region-able.vue";
    import {get_region} from "../../../../classes/region-factory";

    export default {
        mixins: [
            regionAble,
        ],
        components: {
            'scan': require('./scan.vue').default,
            'ship-in-list': require('./ship-in-list.vue').default,
            'layout-header': require('./layout-header.vue').default,
            'layout-footer': require('./layout-footer.vue').default,
        },
        props: {
            // csrf-token
            csrfToken: String,

            /**
             * 로그인 유저 ID
             **/
            loginUserId: {
                type: Number,
                default: null,
            },


            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },

            /**
             * 사용자명
             */
            loginUserName: {
                type: String,
                default: null,
            },

        },
        data: function () {
            return {



                /**
                 * (string) 표시화면
                 *  - scan
                 *  - list
                 */
                screen: 'scan',

                /**
                 * (object) 현재 스캔된 정보
                 *  - ShipIn object
                 */
                scan: null,

                /**
                 * (Array) 스캔내역
                 *  - ShipIn object Array
                 */
                shipInList: [],

                /**
                 * (bool) 자동프린트 옵션
                 */
                autoPrint: Cookies.get('ship-in-auto-print') === 'yes',

                /**
                 * 사운드
                 * https://hearling.com
                 **/
                sound: {
                    normal: null,
                    multi: null,
                    nodata: null,
                    urgent: null,
                    slow_work: null,
                    multi_tracking: null,
                },


            };
        },
        mounted: function () {
            // 사운드 preload
            this.sound.normal = new Audio('/ship-in-sound/normal.mp3');
            this.sound.urgent = new Audio('/ship-in-sound/urgent-box.mp3');
            this.sound.multi = new Audio('/ship-in-sound/multi-match-ko.mp3');
            this.sound.nodata = new Audio('/ship-in-sound/nodata-box.mp3');
            this.sound.slow_work = new Audio('/ship-in-sound/slow-work.mp3');
            this.sound.multi_tracking = new Audio('/ship-in-sound/multi-tracking.mp3');
        },
        computed: {
            /**
             * 스캔 화면 표시
             * @return bool
             */
            displayScan: function () {
                return this.screen === 'scan';
            },

            /**
             * 리스트 표시
             * @return bool
             */
            displayList: function () {
                return this.screen === 'list';
            },
        },
        methods: {
            /**
             * 스캔 이벤트 리스너
             * @param ship_in (object)이벤트 전달값
             */
            scanListener: function (ship_in) {
                // 입고정보에 printable 추가
                ship_in.printable = ship_in.urgent_type === 1
                    || ship_in.classification !== 1;

                // 자동 프린트
                if (this.autoPrint && ship_in.printable) {
                    this.printShipInLabel(ship_in.id);
                }

                // 배치작업을 위한 check 속성추가
                ship_in.checked =  false;

                // 지역(센터)정보 추가
                ship_in.center = get_region(ship_in.region_id);

                // 스캔 결과 저장
                this.scan = ship_in;
                this.shipInList.unshift(ship_in);

                // 소리
                if (ship_in.urgent_type === 1) {
                    this.sound.urgent.play();
                } else if (ship_in.classification === 1) {
                    this.sound.normal.play();
                } else if (ship_in.classification === 2) {
                    this.sound.multi.play();
                } else if (ship_in.classification === 3) {
                    this.sound.nodata.play();
                } else if (ship_in.classification === 4) {
                    this.sound.slow_work.play();
                } else if (ship_in.classification === 5) {
                    this.sound.multi_tracking.play();
                } else if (ship_in.classification === 91) {
                    // todo : 한국반품 EMS입고 사운드 만들어야함.
                }


                this.showScan();

            },

            /**
             * 입고라벨 프린트
             * @param ship_in_id
             **/
            printShipInLabel(ship_in_id) {
                // ajax 옵션
                let opts = {
                    type: 'get',
                    url: '/ship-ins/'+ship_in_id+'/ship-in-label',
                    success: (response, textStatus, jqXHR) => {
                        // 출력
                        $.app.print.label_by_zpls(response.zpls);
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
            
            /**
             * 스캔화면으로 전환
             */
            showScan: function () {
                this.screen = 'scan';

                // 포커싱
                this.$nextTick(() => {
                    this.$refs.scan.focus();
                });

            },

            /**
             * List 화면으로 전환
             */
            showList: function () {
                this.screen = 'list';
            } ,
        },
    }
</script>

<style lang="scss" scoped>
</style>